// This file will be used when migrating from Firebase Auth to Supabase Auth
// For now, it just contains the configuration setup

// Import the required dependencies when ready to use
import { createClient } from "@supabase/supabase-js";

// Supabase configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log("Initializing Supabase client with session persistence");
console.log("Supabase URL:", supabaseUrl ? "URL provided" : "URL missing");
console.log(
  "Supabase Anon Key:",
  supabaseAnonKey ? "Key provided" : "Key missing"
);

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    "Supabase environment variables are missing! Check your .env file."
  );
  // Set reasonable defaults to prevent fatal errors, but the app won't work correctly
  if (!supabaseUrl) supabaseUrl = "https://example.supabase.co";
  if (!supabaseAnonKey) supabaseAnonKey = "missing-key";
}

// Initialize Supabase client with persistence
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storageKey: "script-generator-auth",
    storage: localStorage,
    autoRefreshToken: true,
    debug: true, // Always enable auth debugging until we resolve the issues
  },
});

// Log initial session state and check connection
supabase.auth.getSession().then(({ data, error }) => {
  if (error) {
    console.error("Error retrieving initial session:", error);
  } else {
    console.log(
      "Initial session state:",
      data?.session ? "Session exists" : "No session"
    );

    if (data?.session) {
      console.log("Session user ID:", data.session.user.id);

      // Test a simple query to verify database connection and permissions
      supabase
        .from("auto-scripts")
        .select("count(*)", { count: "exact", head: true })
        .then(({ count, error }) => {
          if (error) {
            console.error("Database connection test failed:", error);

            // Check for RLS policy issues
            if (error.code === "PGRST301") {
              console.error(
                "This appears to be a Row Level Security (RLS) permissions issue."
              );
              console.error(
                "Make sure you have the following RLS policy for the auto-scripts table:"
              );
              console.error(`
CREATE POLICY "Allow full access to authenticated users" ON "public"."auto-scripts"
AS PERMISSIVE FOR ALL
TO authenticated
USING (true)
WITH CHECK (true);
              `);
            }
          } else {
            console.log(
              "Database connection test successful. Total scripts:",
              count
            );
          }
        });
    }
  }
});

/**
 * When ready to migrate from Firebase Auth to Supabase Auth:
 * 1. Uncomment the import and client creation above
 * 2. Create a new service file (e.g., supabaseAuth.service.js) with the same interface as auth.service.js
 * 3. Update the import in AuthContext.js to use the new service
 */

export default supabase;
